/**
 * Created by DSadler on 27/04/2017.
 */
import React, {Component} from 'react';
import * as _ from "lodash";
import StyleItem from "./StyleItem";
import tinymce from "tinymce/tinymce";
import 'tinymce/themes/modern/theme';
import 'tinymce/plugins/code';
import 'tinymce/plugins/link';
import 'tinymce/plugins/anchor';
import 'tinymce/plugins/paste';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/autolink';
import 'tinymce/plugins/charmap';
import 'tinymce/plugins/hr';
import 'tinymce/plugins/textcolor';
import 'tinymce/plugins/colorpicker';
import 'tinymce/plugins/template';
import cheerio from 'cheerio';


class RichText extends Component {
  constructor(props){
    super(props);
    this.state = {
      editor: null,
      visibilityToggled: false,
    };
    this.initEditor = this.initEditor.bind(this);
    this.destroyEditor = this.destroyEditor.bind(this);
    this.saveContent = this.saveContent.bind(this);
  }
  
  componentDidMount() {
    // If we're selected then enable the editor
    if(this.props.currentlySelected) {
      this.initEditor();
    }
  }
  
  componentDidUpdate() {
    // If we're selected and the editor is not active then enable the editor
    if (this.props.currentlySelected && !this.state.editor) {
      this.initEditor();
    }
    
    // If we're not selected and the editor is ACTIVE, save content and destroy the editor
    if (this.state.editor && !this.props.currentlySelected) {
      this.saveContent();
      this.destroyEditor();
    }
  }
  
  componentWillUnmount() {
    // If the editor is active destroy it
    if (this.state.editor) {
      this.destroyEditor();
    }
  }
  
  componentWillReceiveProps(nextProps) {
    let visibilityToggled = nextProps.contentHidden !== this.props.contentHidden;
    this.setState({visibilityToggled});
  }
  
  shouldComponentUpdate(nextProps, nextState) {
    let editing = nextProps.currentlySelected && nextState.editor;
    if (editing && !nextState.visibilityToggled) {
      //console.log("Skipped update");
      return false;
    }
    return true;
  }
  
  initEditor() {
    let component = this;
    let config = {};
    switch (component.props.configEditorType) {
      case "basic":
        config = {
          menubar: false,
          toolbar: false,
          plugins: 'paste',
          external_plugins: {
            paste: "/tinymce/plugins/paste/plugin.min.js",
          },
          paste_word_valid_elements: 'b,strong,em,i,u,strike',
          paste_preprocess: (plugin, args) => {
            debugger;
            let html = cheerio.load(args.content);
            args.content = html.text();
          },
        };
        break;
      case "full":
      default:
        config = {
          menubar: false,
          toolbar: [
            "bold italic underline strikethrough forecolor | ",
            "alignleft aligncenter alignright alignjustify alignnone | ",
            "link unlink anchor template |",
            "paste |",
            "numlist bullist | subscript superscript | hr charmap removeformat |",
            "code"
          ].join(),
          plugins: 'code link paste lists advlist autolink charmap hr textcolor colorpicker template',
/*           external_plugins: {
            code: "/tinymce/plugins/code/plugin.min.js",
            link: "/tinymce/plugins/link/plugin.min.js",
            anchor: "/tinymce/plugins/anchor/plugin.min.js",
            paste: "/tinymce/plugins/paste/plugin.min.js",
            lists: "/tinymce/plugins/lists/plugin.min.js",
            advlist: "/tinymce/plugins/advlist/plugin.min.js",
            autolink: "/tinymce/plugins/autolink/plugin.min.js",
            charmap: "/tinymce/plugins/charmap/plugin.min.js",
            hr: "/tinymce/plugins/hr/plugin.min.js",
          }, */
          paste_word_valid_elements: 'h2,h3,h4,h5,h6,p,span,b,strong,em,i,u,strike,sub,sup,ul,ol,li,a[href],hr',
          textcolor_cols: "6",
          textcolor_rows: "2",
          textcolor_map: [
            "230052", "blue",
            "7f58A5", "purple",
            "6e9bb0", "lblue",
            "ce124e", "red",
            "f26334", "orange",
            "a8ad2c", "green",
            
            "231f20", "black",
            "939596", "grey",
            "53c0a5", "aqua",
            "c59872", "brown",
            "7f2c72", "mauve",
            "fcb316", "yellow",
          ],
          /* eslint-disable no-template-curly-in-string */
          templates: [
            {title: 'Firstname merge tag', description: 'Insert the Clickdimensions merge tag for contact firstname.', content: '${Recipient.contact.firstname}'},
            {title: 'Lastname merge tag', description: 'Insert the Clickdimensions merge tag for contact lastname.', content: '${Recipient.contact.lastname}'},
            {title: 'Fullname merge tag', description: 'Insert the Clickdimensions merge tag for contact fullname.', content: '${Recipient.contact.fullname}'},
            {title: 'Custom salutation merge tag', description: 'Insert the Clickdimensions merge tag for a custom salutation.', content: '${Recipient.contact.abi_customsalutation}'},
            {title: 'Employer name merge tag', description: 'Insert the Clickdimensions merge tag for the contact\'s employer.', content: '${Recipient.contact.parentcustomerid}'},
            {title: 'View email online link', description: 'Insert a link to view this email in a web browser.', content: 'Click <a href="${Gears.microsite()}">here</a> to open this email in your browser.'},
            {title: 'Unsubscribe link', description: 'Insert a link to unsubscribe from all ABI emails.', content: 'Click <a href="${Gears.unsubscribe()}">here</a> to unsubscribe from all ABI newsletters.'},
            {title: 'Manage subscriptions link', description: 'Insert a link to the "My Account" area of the website.', content: 'Manage your ABI subscription preferences <a href="https://www.abi.org.uk/account/">here</a>.'},
          ]
          /* eslint-enable no-template-curly-in-string */
        };
    }
    
    tinymce.init({
      ...config,
      selector: "."+ this.props.contentId + ".editable",
      inline: true,
      forced_root_block: this.props.configEditorRoot,
      browser_spellcheck: true,
      skin_url: '/tinymce/skins/lightgray',
      init_instance_callback: function (editor) {
        // Flag that we're editing
        component.setState({editor});
        
        // Save regularly
        editor.on('Change', (e) => {
          component.saveContent(true);
          component.props.updateContentFrame(component.myNode);
          /*console.log('Editor contents was changed.');*/
        });
        // Save regularly
        editor.on('KeyDown', (e) => {
          component.props.updateContentFrame(component.myNode);
          console.log('Key down.');
          //console.log(e);
        });
        
        component.props.updateContentFrame(component.myNode);
        // Update the frame on everything
      },
    });
  };
  
  destroyEditor() {
    // Commit the contents of the editor to the dom, then kill the editor
    tinymce.remove(this.state.editor);
    this.setState({editor: null});
  };
  
  saveContent(raw) {
    // Save the current contents of the editor cell to the state
    if (raw) {
      this.props.updateContent({contentContent: document.getElementsByClassName(this.props.contentId + " editable")[0].innerHTML});
    } else {
      this.props.updateContent({contentContent: this.state.editor.getContent()});
    }
  };
  
  render() {
    return (
      <td
        id={this.props.contentId}
        className={[this.props.contentId, this.props.viewClass,].join(" ").trim()}
        ref={(node) => {
          this.myNode = node;
          node && node.setAttribute("draggable", this.props.viewAttributes.draggable);
          node && node.setAttribute("id", this.props.viewAttributes.id);
        }}
        {...this.props.eventHandlers}
        style={{
          width: this.props.styleWidth,
          height: this.props.styleHeight,
          backgroundColor: this.props.styleBackgroundColour,
          color: this.props.styleTextColour,
          textAlign: this.props.styleTextAlignment,
        }}
      >
        <StyleItem selectorPrefix={this.props.contentId + " "} styleObject={this.props.viewCss}/>
        {this.props.children}
        <a name={this.props.contentId}/>
        <table
          className="wrapper-table"
          ref={(node) => {
            _.toPairs(this.props.viewAttributes.table).map((item) => {
              return node && node.setAttribute(item[0], item[1]);
            });
          }}
          style={{
            width: this.props.styleWidth,
            height: this.props.styleHeight,
            backgroundColor: this.props.styleBackgroundColour,
            color: this.props.styleTextColour,
            textAlign: this.props.styleTextAlignment,
          }}
        >
          <tbody>
          <tr>
            <td
              className={[this.props.contentId, this.props.viewClass,].join(" ").trim() + " editable"}
              ref={(node) => {
                _.toPairs(this.props.viewAttributes.td).map((item) => {
                  return node && node.setAttribute(item[0], item[1]);
                });
              }}
              style={{
                padding: this.props.stylePadding, //Only applied here
                backgroundColor: this.props.styleBackgroundColour,
                color: this.props.styleTextColour,
                textAlign: this.props.styleTextAlignment,
              }}
              dangerouslySetInnerHTML={{__html: this.props.contentContent}}/>
          </tr>
          </tbody>
        </table>
      </td>
    );
  }
}

export default RichText;


// WEBPACK FOOTER //
// ./src/App/Editor/components/primitives/RichText.js